import { InjectionToken } from '@angular/core';

export const CDN_HOST = new InjectionToken<string>('CDN Host');
